export default __webpack_public_path__ + "static/media/06-460x460.ca2b1f2b.jpeg";